import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'time',
})
export class TimePipe implements PipeTransform {
    constructor() {}

    transform(t:string = ''){
        return t.substr(0,2) + ':' + t.substr(-2);
    }
}



// WEBPACK FOOTER //
// ./src/pipes/time/time.ts